// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3cFWA","inner":"Footer_inner__2eC5f","nextIcon":"Footer_nextIcon__2l_pR","innerLeft":"Footer_innerLeft__3yKAN"};